<mat-slide-toggle *ngIf="!readOnly" (change)="onToggleNetworkChange()"
    [(ngModel)]="genericConfigurations.configureNetwork">
    Configure Network
</mat-slide-toggle>

<table>


    <thead>
        <tr>
            <th>
                Field
            </th>
            <th>
                Current Value
            </th>

            <th>
                Desired Value
            </th>

            <th>
                Status
            </th>
        </tr>
    </thead>

    <tr>
        <td>
            Include locations
        </td>

        <td>



            <mat-list-item *ngFor="let item of currentIncludeLocations; let i = index">
                <div class="flex  items-center w-3/4 ">
                    <span>{{ item }}</span>
                </div>
            </mat-list-item>
        </td>

        <td>
            <mat-radio-group (change)="onIncludeLocationRadioGroupChange()"
                [disabled]="!genericConfigurations.configureNetwork && !override?.includes('includeLocations') "
                [(ngModel)]="genericConfigurations.includeLocations">
                <div class="mb-3">
                    <mat-radio-button [disabled]="readOnly" value="All">Any network or location</mat-radio-button>
                </div>

                <div class="mb-3">
                    <mat-radio-button [disabled]="readOnly" value="AllTrusted">All trusted networks and
                        locations</mat-radio-button>
                </div>

                <div class="mb-3">
                    <mat-radio-button [disabled]="readOnly && !override?.includes('includeLocations')" value="any">
                        Selected networks and locations</mat-radio-button>
                </div>

                <div *ngIf="genericConfigurations.includeLocations === 'any'" class="selected-networks">

                    <mat-list-item *ngFor="let item of includeLocationsNames; let i = index">
                        <div class="flex  items-center w-3/4 ">
                            <span>{{ item }}</span>
                        </div>
                    </mat-list-item>


                    <button color="primary"
                        [disabled]="!genericConfigurations.configureNetwork && !override?.includes('includeLocations') "
                        (click)="selectLocations('includeLocations')" mat-button class="block">
                        Manage
                    </button>


                </div>

            </mat-radio-group>

        </td>

        <td>

            <sway-baseline-status *ngIf="policy?.id" [hasError]="errorsString?.includes('includeLocations') ">
            </sway-baseline-status>

            <mat-icon *ngIf="!policy?.id" class="warn-icon"
                matTooltip="Baseline is not associated with any policy">warning</mat-icon>

        </td>
    </tr>


    <tr>
        <td>
            Exclude locations
        </td>

        <td>

            <mat-list-item *ngFor="let item of currentExcludeLocations; let i = index">
                <div class="flex  items-center w-3/4 ">
                    <span>{{ item }}</span>
                </div>
            </mat-list-item>
        </td>

        <td>
            <mat-radio-group (change)="onExcludeLocationRadioGroupChange()"
                [disabled]="!genericConfigurations.configureNetwork && !override?.includes('excludeLocations')"
                [(ngModel)]="genericConfigurations.excludeLocations ">

                <div class="mb-3">
                    <mat-radio-button [disabled]="readOnly" value="AllTrusted">All trusted networks and
                        locations</mat-radio-button>
                </div>

                <div class="mb-3">
                    <mat-radio-button [disabled]="readOnly && !override?.includes('excludeLocations')" value="any">
                        Selected networks and locations</mat-radio-button>


                </div>

                <div *ngIf="genericConfigurations.excludeLocations ==='any'" class="selected-networks">

                    <mat-list-item *ngFor="let item of excludeLocationsNames; let i = index">
                        <div class="flex  items-center w-3/4 ">
                            <span>{{ item }}</span>
                        </div>
                    </mat-list-item>
                    <button
                        [disabled]="!genericConfigurations.configureNetwork && !override?.includes('excludeLocations')"
                        (click)="selectLocations('excludeLocations')" mat-button color="primary" class="block">
                        Manage
                    </button>


                </div>

            </mat-radio-group>
        </td>

        <td>

            <sway-baseline-status *ngIf="policy?.id" [hasError]="errorsString?.includes('excludeLocations') ">
            </sway-baseline-status>

            <mat-icon *ngIf="!policy?.id" class="warn-icon"
                matTooltip="Baseline is not associated with any policy">warning</mat-icon>

        </td>
    </tr>
</table>
